import { useEffect, useState } from 'react'
import { Button, Grid } from '@mui/material'

const Title = ({ text, isMobiel }) => {

  return (
    <h1 style={{ color: '#E7662B', margin:'20px 0 30px 0' }}>{text}</h1>
  )
}

export default Title
